import { PassiveParametersState } from '../../model/passiveParametersState';
import {
  CLEAR_ALL_ALERT_DETAIL,
  FETCH_ALL_ALERT_DETAIL,
  FETCH_ALL_ALERT_DETAIL_FAILURE,
  FETCH_ALL_ALERT_DETAIL_SUCCESS,
} from '../constants';
import { initialState } from '../system/SystemState';
import { PassiveParametersActionTypes } from '../types/passiveParametersActionTypes';

export default function passiveParametersReducer(
  state = initialState.passiveParameters,
  action: PassiveParametersActionTypes
): PassiveParametersState {
  switch (action.type) {
    case FETCH_ALL_ALERT_DETAIL:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ALL_ALERT_DETAIL_SUCCESS:
      return {
        ...state,
        selectedAlertDetails: action.payload,
        isLoading: false,
      };
    case FETCH_ALL_ALERT_DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case CLEAR_ALL_ALERT_DETAIL:
      return {
        ...state,
        selectedAlertDetails: [],
      };
    default:
      return state;
  }
}
